import {
  ADD_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER,
  PURCHASE_ORDERS,
  ADD_PURCHASE_ORDER_ERROR,
  PURCHASE_ORDER_DETAILS,
  UPDATE_PURCHASE_ORDER,
  PURCHASE_ORDER_REPORTS,
} from "../../types/PurchaseOrderType";
import axios from "axios";
import { toast } from "react-toastify";

const addPurchaseOrderAction = (data) => {
  return {
    type: ADD_PURCHASE_ORDER,
    payload: data,
  };
};

const getPurchaseOrdersAction = (data) => {
  return {
    type: PURCHASE_ORDERS,
    payload: data,
  };
};

const getPurchaseOrderDetailsAction = (data) => {
  return {
    type: PURCHASE_ORDER_DETAILS,
    payload: data,
  };
};

const updatePurchaseOrderAction = (data) => {
  return {
    type: UPDATE_PURCHASE_ORDER,
    payload: data,
  };
};

const deletePurchaseOrderAction = (id) => {
  return {
    type: DELETE_PURCHASE_ORDER,
    payload: id,
  };
};

const getPurchaseOrderReportsAction = (data) => {
  return {
    type: PURCHASE_ORDER_REPORTS,
    payload: data,
  };
};

// Create Purchase Order
export const createPurchaseOrder = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/`,
        data: {
          ...values,
        },
      });

      if (data.success) {
        dispatch(addPurchaseOrderAction(data.order));
        toast.success("Purchase Order Created Successfully");
        return {
          orderId: data.order.id,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Get All Purchase Orders
export const getPurchaseOrders = (filters = {}) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/`,
        params: filters,
      });

      if (data.success) {
        dispatch(getPurchaseOrdersAction(data));
        return {
          orders: data.orders,
          pagination: data.pagination,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Get Purchase Order by ID
export const getPurchaseOrderById = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/${id}`,
      });

      if (data.success) {
        dispatch(getPurchaseOrderDetailsAction(data));
        return {
          order: data.order,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Update Purchase Order
export const updatePurchaseOrder = (id, values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/${id}`,
        data: {
          ...values,
        },
      });

      if (data.success) {
        dispatch(updatePurchaseOrderAction(data.order));
        toast.success("Purchase Order Updated Successfully");
        return {
          order: data.order,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Delete Purchase Order
export const deletePurchaseOrder = (id) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "delete",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/${id}`,
      });

      if (data.success) {
        dispatch(deletePurchaseOrderAction(id));
        toast.success("Purchase Order Deleted Successfully");
        return {
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};

// Update Purchase Order Item Received (and optionally purchase_price).
// payload: { item_id, received_quantity?, purchase_price? } or { items: [{ item_id, received_quantity?, purchase_price? }, ...] }.
export const updatePurchaseOrderItemReceived = (orderId, payload) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "put",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/${orderId}/received`,
        data: payload,
      });

      if (data.success) {
        toast.success("Received Quantity Updated Successfully");
        dispatch(getPurchaseOrderById(orderId));
        return { message: "success" };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return { message: "error" };
    }
  };
};

// Get Purchase Order Reports
export const getPurchaseOrderReports = (reportType, filters = {}) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `purchase-order/reports/${reportType}`,
        params: filters,
      });

      if (data.success) {
        dispatch(getPurchaseOrderReportsAction({ reportType, data }));
        return {
          data: data,
          message: "success",
        };
      }
    } catch (error) {
      toast.error(error.response?.data?.error || error.message);
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};
